import React from 'react';
import { themr } from 'react-css-themr';
import { PolylineMarker } from 'common/components/core/map/PolylineMarker';
import Icon from 'common/components/core/icon';

import theme from './SegmentMarker.scss';

class SegmentMarker extends React.PureComponent {
    render() {
        const { theme, className, sideLength } = this.props;
        return (
            <PolylineMarker
                sideLength={sideLength}
                className={className}
                markerIcon={
                    <Icon
                        theme={theme}
                        className={theme.segmentIcon}
                        icon="circle"
                    />
                }
                theme={theme}
            />
        );
    }
}

SegmentMarker.defaultProps = {
    sideLength: 8
};

const ThemedSegmentMarker = themr('SegmentMarker', theme)(SegmentMarker);
export default ThemedSegmentMarker;
export { ThemedSegmentMarker as SegmentMarker };
